import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { feedAuditPlatformSearchSchema } from '~/features/feed-audit/constants/feed-audit-platform';
import { requireTenantAdmin } from '~/utils/guards';

const FeedAuditCreatePage = lazy(
  () => import('~/features/feed-audit/pages/feed-audit-create-page'),
);

// Starting a run is subsidiary/super-admin only; members get read-only Feed Audit.
export const Route = createFileRoute('/_authenticated/_tenant/feed-audit/create')({
  // `?platform=google|meta` picks the channel the audit runs for (default Google).
  validateSearch: feedAuditPlatformSearchSchema,
  beforeLoad: requireTenantAdmin('/feed-audit'),
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <FeedAuditCreatePage />
    </Suspense>
  ),
});
